import { Loader2 } from 'lucide-react';
import { useState, useEffect, useRef } from 'react';
import CrossfadeImage from '../../CrossfadeImage';
import LoadingIndicator from '../LoadingIndicator';
import { cn } from '@/utils';

interface ImagePreviewProps {
  previewImage?: string;
  imageId?: string;
  isGenerating?: boolean;
  imageGenerationStartTime?: number;
  onImageClick?: () => void;
}

export default function ImagePreview({ previewImage, imageId, onImageClick }: ImagePreviewProps) {
  if (!previewImage && !imageId) return null;

  return (
    <div
      className={cn('relative w-full h-full', imageId && 'cursor-pointer')}
      onClick={imageId ? onImageClick : undefined}
      id={imageId}
    >
      <CrossfadeImage
        src={
          imageId
            ? `https://imagedelivery.net/xE-VtsYZUS2Y8MtLMcbXAg/${imageId}/orig`
            : previewImage
        }
        containerClass="w-full h-full"
        imgClass="w-full h-full object-contain"
        duration={imageId ? 300 : 4000}
      />
      {/* Overlay with jumping dots */}
      {!previewImage && !imageId && (
        <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
          <LoadingIndicator />
        </div>
      )}
    </div>
  );
}
